import "../../styles/common/errorToast.css";

const ErrorToast = ({ error, background = true }) => {
  if (!error) return;
  return (
    <div className="error-display-outer">
      <div
        className={
          background ? "error-display red-background" : "error-display"
        }
      >
        {error}
      </div>
    </div>
  );
};

export default ErrorToast;
